import React from 'react';
import { Home, Briefcase, Users, Shield, Calculator, Gavel } from 'lucide-react';

export const services = [
  {
    icon: <Home className="h-8 w-8 text-blue-600" aria-hidden="true" />,
    title: "Real Estate Law",
    description: "Complete support for property transactions, from legal work to practical assistance with mortgages, contractors, and property management."
  },
  {
    icon: <Briefcase className="h-8 w-8 text-blue-600" aria-hidden="true" />,
    title: "Commercial Law",
    description: "Comprehensive business support including due diligence, contracts, and practical guidance for international business operations."
  },
  {
    icon: <Users className="h-8 w-8 text-blue-600" aria-hidden="true" />,
    title: "Labor Law",
    description: "Employment contracts, worker rights, and immigration work permit assistance with cultural context."
  },
  {
    icon: <Shield className="h-8 w-8 text-blue-600" aria-hidden="true" />,
    title: "Family Law",
    description: "International will preparation, power of attorney, and cross-border family legal support with cultural sensitivity."
  },
  {
    icon: <Calculator className="h-8 w-8 text-blue-600" aria-hidden="true" />,
    title: "Tax Law",
    description: "Strategic tax consulting for international clients, ensuring compliance while optimizing tax positions."
  },
  {
    icon: <Gavel className="h-8 w-8 text-blue-600" aria-hidden="true" />,
    title: "Tort Law",
    description: "Comprehensive support for personal injury, medical malpractice, and civil wrongs with full-service assistance."
  }
];